import {Tooltip, TooltipProps} from '@mui/material';
import {forwardRef} from 'react';

export interface AppTooltipProps extends TooltipProps {}

export const AppTooltip = forwardRef<HTMLDivElement, AppTooltipProps>(({children, ...rest}, ref) => {
    return (
        <Tooltip {...rest}>
            <span ref={ref}>{children}</span>
        </Tooltip>
    );
});

export default AppTooltip;
